export const apiTypes = {
    NO_CONTENT: 204,
    UNAUTHORIZED: 401,
    SUCCESS: 200
}